import { licenseFeeService } from "@/services/license-fee-service";
import { LoaderFunctionArgs, redirect } from "react-router-dom";
import {
  tierOptions,
  providerOptions,
  paymentMethodOptions,
} from "@/features/license-fee/list/utils/license-fee-mappings";
import { safeFormatInTimeZone } from "@/utils/format/safe-format-in-time-zone";
import { companyService } from "@/services/company-service";

export const loader = async ({ params }: LoaderFunctionArgs) => {
  if (!params.licenseFeeId) throw redirect("/");

  const licenseFee = await licenseFeeService.getLicenseFeeById(
    Number(params.licenseFeeId),
  );

  const companyPackages = await companyService.getCompanyPackages({
    companyId: Number(licenseFee.companyId),
    take: 1000,
  });

  return {
    licenseFee: {
      ...licenseFee,
      startDate: safeFormatInTimeZone(
        licenseFee.startDate,
        "UTC",
        "yyyy-MM-dd",
      ),
      endDate: safeFormatInTimeZone(licenseFee.endDate, "UTC", "yyyy-MM-dd"),
    },
    tierOptions,
    providerOptions,
    paymentMethodOptions,
    companyPackages: companyPackages.map((companyPackage) => ({
      value: companyPackage.id.toString(),
      label: companyPackage.name,
    })),
  };
};

export type LoaderData = Awaited<ReturnType<typeof loader>>;
